/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// TODO: This file is a mess. It needs to be refactored and cleaned up. At least split the logic of an order view vs a ticket view into separate components.
import React from 'react';
import { TicketsList } from "./tickets_list.js.jsx";
import * as RegistrationUtilities from '../../utilities';

const ShareLinksEmphasis = props => <div className="table-buttons">
  <a href={props.twitterShareUrl} target="_blank" rel="noreferrer" ><i className="fab fa-x-twitter"></i></a>
  <a href={props.facebookShareUrl} target="_blank" rel="noreferrer" ><i className="fab fa-facebook-f"></i></a>
</div>;

const ShareLinksOldTheme = props => <div className="table-buttons">
  <a href={props.twitterShareUrl} target="_blank" rel="noreferrer" ><span className="fab fa-2x fa-x-twitter"></span><br/>X</a>
  <a href={props.facebookShareUrl} target="_blank" rel="noreferrer" ><span className="fa fa-2x fa-facebook"></span><br/>Facebook</a>
</div>;

export class Confirmation extends React.Component {
  constructor(...args) {
    super(...args);
    this.onCancel = this.onCancel.bind(this);
    this.onRequestRefund = this.onRequestRefund.bind(this);
  }

  static initClass() {
    this.defaultProps =
      {confirmation_view: 'order'};
  }

  onCancel(event) {
    event.preventDefault();
    return (typeof this.props.onCancel === 'function' ? this.props.onCancel() : undefined);
  }

  onRequestRefund(event) {
    event.preventDefault();
    return (typeof this.props.onRequestRefund === 'function' ? this.props.onRequestRefund() : undefined);
  }

  render() {
    let is_denied; let is_refund_requested; let is_refunded; let ticket_status;
    if (this.props.loading) {
      return <div className="em-register_confirm widget-content">Loading...</div>;
    }

    const facebook_share_url = `https://www.facebook.com/share.php?u=${encodeURIComponent(this.props.event_url)}`;

    const twitter_message = `I'm going! Are you? ${this.props.event_name}`;
    const twitter_share_url = `https://x.com/intent/tweet?url=${encodeURIComponent(this.props.event_url)}&text=${encodeURIComponent(twitter_message)}&hashtags=${encodeURIComponent(this.props.event_hashtag)}&via=localist`;

    const ShareLinks = this.props.uses_modal ? ShareLinksEmphasis : ShareLinksOldTheme;

    const {
      organizer_email
    } = this.props.order_details.event_instance;

    const is_order = this.props.confirmation_view === 'order';
    let {
      grand_total
    } = this.props.order_details.order;

    if (!is_order) {
      const ticket = this.props.order_details.tickets[0];
      const ticket_state = ticket.state;
      is_refund_requested = ticket_state === 'refund_requested';
      is_refunded = ticket_state === 'refunded';
      is_denied = ticket_state === 'refund_denied';
      const is_free = ticket.grand_total === 0;
      ticket_status = ticket_state;
      ({
        grand_total
      } = ticket);
    }

    return <div className="em-register_confirm widget-content">
        <h2>Your order for {this.props.event_name}</h2>

        <p className="em-ticket-date">
          <i className="fa fa-calendar"></i>
          {this.props.formatInstanceDate(this.props.order_details.event_instance)}
        </p>

        {is_order || (!is_order && is_denied) && this.props.event_location && <p className="em-event-location">
          <i className="fas fa-map-marker-alt"></i>
          {this.props.event_location_url ? <a href={this.props.event_location_url}>{this.props.event_location}</a> : this.props.event_location}
        </p>}

        <p className="em-ticket-info">
          <i className="fas fa-ticket-alt"></i>
          {this.props.order_details.tickets.length}x {this.props.order_details.tickets.length == 1 ? 'Ticket' : 'Tickets'} {is_order ? "" : ` - ${  RegistrationUtilities.ticket_status_lookup(ticket_status)}`} - {RegistrationUtilities.formatCurrency(grand_total, this.props.currency)} total
        </p>

        {is_order && <p className="em-register_confirm-info">
          You will be receiving an email confirmation with your order attached. Attendees will also be receiving their tickets in their emails.
        </p>}

        <p>
          If you have any questions about your order, reply directly to the confirmation email, or contact the organizer below.
        </p>

        <div className="confirm_share_box">
          <label>Share your plans</label>

          <ShareLinks twitterShareUrl={twitter_share_url}
                      facebookShareUrl={facebook_share_url} />
        </div>

        <ul className="em-actions-list">
          <li className="em-list-item">
            <a href="#" className="cancel_link em-link" onClick={this.onCancel}>Buy More Tickets</a>
          </li>
          {(is_order && this.props.hasRefundableTickets(this.props.order_details.tickets) || (!is_order && !is_denied && !is_refund_requested && !is_refunded)) && <li className="em-list-item">
            <a href="#" className="em-link" onClick={this.onRequestRefund}>Cancel or Request a Refund</a>
          </li>}

          {organizer_email && <li className="em-list-item">
            <a href={RegistrationUtilities.organizerTicketMailTo(organizer_email, this.props.event_name)} className="em-link">Contact Organizer</a>
          </li>}
        </ul>

        <div className="em-order-summary em-divider">
          <h3 className="em-order-title">Order Summary</h3>

          <p className="em-order-info">
            Order #{this.props.order_details.order.order_id} - Paid on {moment(this.props.order_details.order.paid_at).format("MMMM D, YYYY")}
          </p>

          <TicketsList tickets={this.props.order_details.tickets}
                       orderDetails={this.props.order_details.order}
                       currency={this.props.currency}
                       showTotal />

        </div>
      </div>;
  }
}
Confirmation.initClass();

